import { Container, Stack, Typography, Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import checkmarkCircleFill from '@iconify/icons-eva/checkmark-circle-fill';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
//
import Header from '../components/_landingpage/LandingHeader';
import Footer from '../components/Footer';
import * as myLayananService from '../services/mylayanan';
import * as pdfService from '../services/pdf';
import { getAPIURL } from '../utils/envGetter';

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true
};

const PDFScan = ({ user }) => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [myLayanan, setMyLayanan] = React.useState({});
  const [type, setType] = React.useState({});
  const [metaKey, setMetaKey] = React.useState({});
  const [filePath, setFilePath] = React.useState('');

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const getFilePath = (documentPath, type) => {
    const origin = getAPIURL();
    if (!documentPath) return;
    const path = `${origin}/pdf/scan?path=${documentPath
      .replace('.', '')
      .substring(1)}&filename=${getType(type)}`;
    return path;
  };

  const getMyLayanan = async () => {
    try {
      const result = await myLayananService.getLayananByIDPublicReqe(id);
      setMyLayanan(result.data);

      const { attributes } = result.data;

      Object.entries(attributes).forEach(([key, value]) => {
        if (value === id) setType(key);
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getMyLayanan();
  }, [id]);

  React.useEffect(() => {
    if (_.isEmpty(myLayanan)) return;
    let metakey = '';
    if (type === 'id_kategorisasi_se') {
      metakey = 'kategori_se';
    }
    if (type === 'id_permohonan') {
      metakey = 'data_permohonan';
    }
    if (type === 'id_feedback') {
      metakey = 'feedback';
    }
    setMetaKey(metakey);
  }, [type]);

  const updateFilePath = () => {
    if (_.isEmpty(myLayanan)) return;
    const path = getFilePath(myLayanan?.meta[metaKey]?.document_path, type);

    if (path) setFilePath(path);
  };

  React.useEffect(() => {
    updateFilePath();
  }, [metaKey]);

  const getType = (type) => {
    let text = '';
    if (type === 'id_kategorisasi_se') {
      text = 'Kategorisasi SE';
    }
    if (type === 'id_permohonan') {
      text = 'Dokumen Permohonan';
    }
    if (type === 'id_feedback') {
      text = 'Dokumen Rekomendasi';
    }
    return text;
  };

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{ minHeight: '100vh' }}
      justifyContent="space-between"
    >
      <Header user={user} />
      <Stack direction="column" spacing={2}>
        <Container maxWidth="lg">
          <Stack direction="column" spacing={2}>
            <Typography variant="h4">SCAN PDF</Typography>
            {type && <Typography variant="body1">Tipe Dokumen: {getType(type)}</Typography>}
            {!_.isEmpty(myLayanan) && (
              <SignedDocumentInfo
                path={myLayanan?.meta[metaKey]?.document_path?.replace('.', '').substring(1)}
              />
            )}
            <iframe style={{ height: '100vh' }} title="Dokumen" src={filePath} />
          </Stack>
        </Container>
      </Stack>
      <Footer />
    </Stack>
  );
};

const SignedDocumentInfo = ({ path }) => {
  const [info, setInfo] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const theme = useTheme();

  const getInfo = async (path) => {
    try {
      setLoading(true);
      if (!path) return;
      const body = {
        document_path: path,
        type: 'api'
      };

      const result = await pdfService.verifyPDF(body);
      setInfo(result.response);
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    getInfo(path);
  }, [path]);

  return (
    <>
      {loading && (
        <Stack direction="row" spacing={2} alignItems="center">
          <CircularProgress size={24} />
          <Typography variant="body2">Mengambil informasi penandatangan ...</Typography>
        </Stack>
      )}
      {!_.isEmpty(info) && (
        <Stack direction="column" spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>{info.notes}</Typography>

            <Icon
              icon={checkmarkCircleFill}
              color={theme.palette.primary.main}
              width={24}
              height={24}
            />
          </Stack>
          <Typography>Penandatangan: </Typography>

          {!_.isEmpty(info?.details) &&
            info?.details?.map((item, index) => (
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography>{index + 1}.</Typography>
                <Typography>
                  {item?.info_signer?.signer_name} - {item?.signature_document?.signed_in}
                </Typography>
              </Stack>
            ))}
        </Stack>
      )}
    </>
  );
};

const ErrorPage = () => {
  const data = '';
  return <Typography>Maaf, terjadi kesalahan dalam memuat dokumen PDF</Typography>;
};

const LoadingPDF = () => {
  const data = '';
  return <Typography>Memuat dokumen ...</Typography>;
};

export default PDFScan;
